/**
 * Analytics utilities for AuthFlow™
 * Supports multiple analytics platforms for international users
 */

// Bing Analytics tracking (Clarity)
export const trackBingEvent = (eventName: string, properties?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.clarity) {
    window.clarity('event', eventName, properties);
  }
};

export const trackBingPageView = (page: string) => {
  if (typeof window !== 'undefined' && window.clarity) {
    window.clarity('set', 'page', page);
  }
};

// Google Analytics 4 tracking
export const trackGAEvent = (eventName: string, params?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
};

// Unified tracker — fires both Clarity and GA4 in one call
// Only sends tracking events if the hostname is www.authflow.net
export const track = (eventName: string, properties?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.location.hostname === 'www.authflow.net') {
    trackBingEvent(eventName, properties);
    trackGAEvent(eventName, properties);
  }
};

// Vercel Analytics (automatically handled by the Analytics component)

// Type declarations for analytics platforms
declare global {
  interface Window {
    clarity: (command: string, ...args: any[]) => void;
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}